import { render, staticRenderFns } from "./allSportsModal.vue?vue&type=template&id=1dafefe9&lang=pug&"
import script from "./allSportsModal.vue?vue&type=script&lang=js&"
export * from "./allSportsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports